import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";

function CustomTabPanel({ children, value, index, id_type, ...other }) {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`${id_type}-tabpanel-${index}`}
            aria-labelledby={`${id_type}-tab-${index}`}
            {...other}
        >
            {value === index && <SoftBox >{children}</SoftBox>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    id_type: PropTypes.string
};

export default CustomTabPanel;